import React from 'react';
import { Wrapper } from '../../../components/Wrapper';
import { InterfaceWrapper } from '../../../components/InterfaceWrapper';
import { PlayerInterface } from './PlayerInterface';

import { Content } from './Content';

export const RoundNumber = InterfaceWrapper({
  Interface: PlayerInterface,
  Step: ({ data, context }) => {
    return (
      <Wrapper>
        <Content data={data} context={context} />
      </Wrapper>
    );
  },
});
